module.exports = __webpack_public_path__ + "img/106.4.3fdab235.png";